<kzn-dialog
  [title]="t('signerDetails')"
  [actionLabel]="t('close')"
  [showSecondaryAction]="false"
  (actionFired)="onClose()">
  <div class="request-details-dialog" [class.request-details-dialog--loading]="isLoading">
    @if (isLoading) {
      <div class="request-details-dialog__loading">
        <mat-spinner diameter="40"></mat-spinner>
        <span>{{ t('loadingSignerDetails') }}</span>
      </div>
    } @else if (errorMessage) {
      <p class="request-details-dialog__error">{{ errorMessage }}</p>
    } @else {
      <div class="request-details-dialog__table-container">
        <table class="request-details-unified-table">
          <thead>
            <tr>
              <th class="request-details-dialog__col-order">{{ t('order') }}</th>
              <th class="request-details-dialog__col-name">{{ t('signerName') }}</th>
              <th class="request-details-dialog__col-email">{{ t('signerEmail') }}</th>
              <th class="request-details-dialog__col-role">{{ t('signerRole') }}</th>
              <th class="request-details-dialog__col-phone">{{ t('phone') }}</th>
              <th class="request-details-dialog__col-date">{{ t('signDate') }}</th>
              <th class="request-details-dialog__col-resend">{{ t('resendReminder') }}</th>
            </tr>
          </thead>
          <tbody>
            @for (detail of details; track detail.Id || $index) {
              <tr>
                <td>{{ detail.Order || '—' }}</td>
                <td>{{ detail.SignerName || '—' }}</td>
                <td class="request-details-dialog__email">{{ detail.SignerEmail || '—' }}</td>
                <td>{{ detail.SignerRole || '—' }}</td>
                <td>{{ detail.Phone || '—' }}</td>
                <td>{{ formatSignDate(detail) }}</td>
                <td class="request-details-dialog__action-cell">
                  @if (isResendingSigner(detail)) {
                    <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                  } @else {
                    <button
                      type="button"
                      class="request-details-dialog__resend-btn"
                      [disabled]="!canResendSigner(detail) || isAnyResendInProgress()"
                      (click)="onResendSigner(detail)">
                      {{ t('resendReminder') }}
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</kzn-dialog>
